export default __webpack_public_path__ + "static/media/logo.393df3f4.svg";